import React, { createContext, useCallback, useContext, useState } from "react";
import { useNotification } from "../notification-context";
import { postAuthenticatedRequest } from "../../../utils/api/requests/request";
import { cleanObject } from "../../../utils/helper/format";

const DepositContext = createContext();

export const DepositProvider = ({ children }) => {
  const { triggerNotification } = useNotification();
  const [allDeposits, setAllDeposits] = useState(null);
  const [isAllDepositLoading, setIsAllDepositLoading] = useState(false);
  const [depositByIdDetails, setDepositByIdDetails] = useState(null);
  const [isDepositByIdLoading, setIsDepositByIdLoading] = useState(false);
  const [filter, setFilter] = useState({
    status: "",
    productId: "",
    searchText: "",
    startDate: "",
    endDate: "",
  });

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalName) => {
    setActiveModal(modalName);
  };
  const closeModal = () => {
    setActiveModal(null);
  };

  const getAllDeposits = useCallback(
    async ({ filter, pagination }) => {
      try {
        setIsAllDepositLoading(true);

        // Filter out properties with empty values
        const cleanedFilter = cleanObject({ ...filter, ...pagination });

        // console.log("cleaned filter is", cleanedFilter);

        const response = await postAuthenticatedRequest(
          "RetrieveDepositListQuery",
          { ...cleanedFilter },

          true
        );

        const result = response?.outData;
        if (result?.isSuccessful) {
          console.log("result?.data from deposit", result?.data);
          setAllDeposits(result);
        } else {
          triggerNotification({
            type: "error",
            message: "Error",
            description: result?.message,
          });
        }
      } catch (error) {
        triggerNotification({
          type: "error",
          message: "Error",
          description: error?.message,
        });
      } finally {
        setIsAllDepositLoading(false);
      }
    },
    [triggerNotification]
  );

  const getDepositById = useCallback(async (depositId) => {
    try {
      setIsDepositByIdLoading(true);

      const response = await postAuthenticatedRequest(
        "RetrieveDepositByIdQuery",
        { id: depositId },
        true
      );

      const result = response?.outData;
      if (result?.isSuccessful) {
        console.log("result?.data from deposit", result?.data);
        setDepositByIdDetails(result);
      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      triggerNotification({
        type: "error",
        message: "Error",
        description: error?.message,
      });
    } finally {
      setIsDepositByIdLoading(false);
    }
  }, []);

  return (
    <DepositContext.Provider
      value={{
        allDeposits,
        isAllDepositLoading,
        getAllDeposits,
        filter,
        setFilter,
        pagination,
        setPagination,
        depositByIdDetails,
        isDepositByIdLoading,
        getDepositById,
        activeModal,
        openModal,
        closeModal,
      }}
    >
      {children}
    </DepositContext.Provider>
  );
};

export const useDeposit = () => {
  return useContext(DepositContext);
};
